// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3-de_","label":"Radio_label__2HkW0","checkMark":"Radio_checkMark__38qke","disabled":"Radio_disabled__1XwDV"};